export default __webpack_public_path__ + "static/media/billing.065cfc98.svg";